export default {
  bind (el, binding, vNode) {
    const handler = e => {
      e.stopPropagation()

      const DIMMABLE_LIST = 'jade-floating__overlay is-dimmable'
      const isDimmable = e.target.className === DIMMABLE_LIST

      const outsideEvent =
        isDimmable || (!el.contains(e.target) && el !== e.target)

      if (outsideEvent && binding.value.escapeKey && e.key === 'Escape') {
        binding.value.event(e)
        return
      }

      const bubble = binding.modifiers.bubble

      if (bubble || (outsideEvent && binding.value.outsidePress)) {
        binding.value.event(e)
      }
    }

    el.__vueDismiss__ = handler

    document.addEventListener(
      binding.value.outsidePressEvent,
      el.__vueDismiss__,
      {
        passive: true
      }
    )

    document.addEventListener('keydown', el.__vueDismiss__, {
      passive: true
    })
  },
  unbind (el, binding) {
    document.removeEventListener(
      binding.value.outsidePressEvent,
      el.__vueDismiss__,
      {
        passive: true
      }
    )

    document.removeEventListener('keydown', el.__vueDismiss__, {
      passive: true
    })

    el.__vueDismiss__ = null
  }
}
